import { settingsRouting } from './settings.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { SettingsComponent } from './settings.component';
import { PersonalInfoComponent } from './personal-info';
import { ChangePasswordComponent } from './change-password';
import { PasswordFormComponent,
         PersonalInfoViewComponent, PersonalInfoEditComponent } from './shared/ui';

import { SettingsService } from './shared/services';

@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        settingsRouting,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        SettingsComponent,
    ],
    declarations: [
       SettingsComponent,
       PersonalInfoComponent,
       ChangePasswordComponent,
       PasswordFormComponent,
       PersonalInfoViewComponent,
       PersonalInfoEditComponent
    ],
    providers: [
        SettingsService
    ],
})
export class SettingsModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/settings.module.ts